










































import { Component, Mixins, Watch } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import { ExactPartSearchResultInfo } from '@/entities/ExactPartSearchResultInfo';
import _ from 'lodash/fp';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';
import { LoadingState } from '@/entities/LoadingState';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';

@Component({
    components: {
        ShoppingCartActions,
    },
})
export default class DirectInput extends Mixins(BaseMixin) {
    private searchForPartsDebounced: (partNumber: string) => void = _.debounce(
        500,
        (partNumber: string) => {
            this.searchForParts(partNumber);
        }
    );
    private loadingFunction?: (isLoading: boolean) => void;
    private selectedPart: ExactPartSearchResultInfo | null = null;

    protected created(): void {
        // clear parts when popup gets visible again
        this.clearFoundParts();
    }

    private get isLoading(): boolean {
        return (
            this.$store.getters[
                ShoppingCartModuleTypes.getters.partSearchState
            ] === LoadingState.Loading
        );
    }

    private get foundParts(): ExactPartSearchResultInfo[] {
        return this.$store.getters[
            ShoppingCartModuleTypes.getters.foundPartsByDirectInput
        ];
    }

    private partNumberEntered(
        partNumber: string,
        loadingFunction: (isLoading: boolean) => void
    ): void {
        if (isNullOrWhitespace(partNumber)) {
            return;
        }
        this.loadingFunction = loadingFunction;
        this.searchForPartsDebounced(partNumber);
    }

    private searchForParts(partNumber: string): void {
        this.$store.dispatch(
            ShoppingCartModuleTypes.actions.searchForPartsByPartNumber,
            {
                partNumber,
            }
        );
    }

    @Watch('isLoading')
    private loadingStateChanged(): void {
        if (this.loadingFunction) {
            this.loadingFunction(this.isLoading);
        }
    }

    private selectedPartChanged(value: ExactPartSearchResultInfo): void {
        if (value) {
            this.selectedPart = value;
        } else {
            this.selectedPart = null;
            this.clearFoundParts();
        }
    }

    private clearFoundParts(): void {
        this.$store.dispatch(
            ShoppingCartModuleTypes.actions.clearFoundPartsByDirectInput
        );
    }
}
